"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const carrier_1 = require("../../carrier");
class ClaimDetails {
    constructor(lossDate, description, causeOfLoss, additionalCharges, deliveryNoteComment, invoiceValue, lossLocation, lossCarriers, requestedClaimValue, policeReportId, policeAgency, otherDeliveryNoteComment, causeOfTemperatureRelatedIssue, itemsShipped, causeOfDamage, itemsMissing, lossOccurredCarrier) {
        this.lossDate = lossDate;
        this.description = description;
        this.causeOfLoss = causeOfLoss;
        this.additionalCharges = additionalCharges;
        this.deliveryNoteComment = deliveryNoteComment;
        this.invoiceValue = invoiceValue;
        this.lossLocation = lossLocation;
        this.lossCarriers = lossCarriers;
        this.requestedClaimValue = requestedClaimValue;
        this.policeReportId = policeReportId;
        this.policeAgency = policeAgency;
        this.otherDeliveryNoteComment = otherDeliveryNoteComment;
        this.causeOfTemperatureRelatedIssue = causeOfTemperatureRelatedIssue;
        this.itemsShipped = itemsShipped;
        this.causeOfDamage = causeOfDamage;
        this.itemsMissing = itemsMissing;
        this.lossOccurredCarrier = lossOccurredCarrier;
    }
    static fromObj(data = {}) {
        var _a;
        const lossCarriers = ((_a = data.lossCarriers) === null || _a === void 0 ? void 0 : _a.length)
            ? data.lossCarriers.map((obj) => carrier_1.getCarrierEntityByMode(obj))
            : [];
        return new ClaimDetails(data.lossDate, data.description, data.causeOfLoss, data.additionalCharges, data.deliveryNoteComment, data.invoiceValue, data.lossLocation, lossCarriers, data.requestedClaimValue, data.policeReportId, data.policeAgency, data.otherDeliveryNoteComment, data.causeOfTemperatureRelatedIssue, data.itemsShipped, data.causeOfDamage, data.itemsMissing, data.lossOccurredCarrier);
    }
}
exports.default = ClaimDetails;
//# sourceMappingURL=claimDetails.class.js.map